// removed by extract-text-webpack-plugin
module.exports = {"MenuList":"Videos__MenuList__3FkjG","ActiveMenu":"Videos__ActiveMenu__2V1UI","VideoTitle":"Videos__VideoTitle__1tgcE"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Videos/Videos.css
// module id = 247
// module chunks = 0